import { render, staticRenderFns } from "./CbrUpdatesTotalItem.vue?vue&type=template&id=62e28b0d&scoped=true&lang=pug&"
import script from "./CbrUpdatesTotalItem.vue?vue&type=script&lang=js&"
export * from "./CbrUpdatesTotalItem.vue?vue&type=script&lang=js&"
import style0 from "./CbrUpdatesTotalItem.vue?vue&type=style&index=0&id=62e28b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e28b0d",
  null
  
)

export default component.exports